import { ButtonHTMLAttributes, FC, ReactNode } from 'react';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode;
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const Button: FC<ButtonProps> = ({
  children,
  variant = 'primary',
  size = 'md',
  className = '',
  ...props
}) => {
  const baseClasses =
    'inline-flex items-center justify-center font-medium transition duration-300 rounded-full text-center whitespace-nowrap';

  const variantClasses = {
    primary:
      'bg-red-800 text-white hover:bg-red-700 focus:ring-2 focus:ring-red-500 focus:ring-opacity-50',
    outline:
      'bg-transparent border-2 border-red-800 text-red-800 hover:bg-red-800 hover:text-white focus:ring-2 focus:ring-red-500 focus:ring-opacity-50',
    secondary:
      'bg-transparent border-2 border-red-800 text-red-800 hover:bg-red-800 hover:text-white focus:ring-2 focus:ring-red-500 focus:ring-opacity-50',
  };

  const sizeClasses = {
    sm: 'px-3 sm:px-4 py-2 text-sm',
    md: 'px-4 sm:px-6 py-2 sm:py-3 text-sm sm:text-base',
    lg: 'px-6 sm:px-8 py-3 sm:py-4 text-base sm:text-lg',
  };

  const classes = `${baseClasses} ${variantClasses[variant]} ${sizeClasses[size]} ${className}`;

  return (
    <button className={classes} {...props}>
      {children}
    </button>
  );
};

export default Button;
